import { get } from "@/shared/api"
import { API_ENDPOINTS } from "@/shared/api/endpoints"

import type { BudgetTerm } from "./types"

export const budgetTermService = {
  index: async (): Promise<BudgetTerm[]> => {
    const response = await get<BudgetTerm[]>(API_ENDPOINTS.BUDGET_TERMS)
    const items = response.data
    return Array.isArray(items) ? items : []
  },
}
